<template>

	<li
		class="footer__column__item"
		:class="{'hide__sm': item.hideOnMobile}"
	>
		<a :href="generateExternalUrl(item)"
		   target="_blank"
		   class="footer__column__item__hovered"
		   v-if="item.href"
		   :class="{flex: item.productLogo, 'align-center': item.productLogo}"
		>
			<slot name="logo"></slot>
			<span class="footer__column__item__text">
				<i class="fa footer__column__item__icon"
				   v-if="item.icon" :class="item.icon"
				></i>{{ $t(item.title) }}
			</span>
		</a>

		<span class="footer__column__item__hovered"
			  v-if="item.clickEvent"
			  @click.prevent="$emit('clickEvent', item.clickEvent)"
		>
			<span class="footer__column__item__text">
				{{ $t(item.title) }}
			</span>
		</span>

		<ul
			class="footer__column__item__sublist"
			v-if="item.subList"
		>
			<li
				class="footer__column__item"
				v-for="(subItem, subIndex) in item.subList"
				:key="`__${subIndex}`"
			>
				<a :href="generateExternalUrl(subItem)" class="footer__column__item__hovered" target="_blank">
					<span class="footer__column__item__text">
						{{ $t(subItem.title) }}
					</span>
				</a>
			</li>
		</ul>
	</li>

</template>

<script>

	import { generateUrl } from "@/plugin/mixins";

	export default {
		data: function () {
			return {

			}
		},
		props: ['item'],
		mixins: [generateUrl]
	}

</script>